<template>
    <div class="site" @keyup.enter="gotoIndex" tabindex="0" v-show="showHome">
        <div class="headerbox">
            <header class="header">
                <div class="cloumn1"><img src="../assets/images/home/logo.png"/></div>
                <div class="cloumn2">
                    <Button type="primary" class="button" @click="gotoIndex"
                    >进入主页
                    </Button
                    >
                </div>
            </header>
        </div>
        <div class="swiper">
            <Carousel
                    v-model="value"
                    :autoplay="true"
                    :autoplay-speed="20000"
            >
                <CarouselItem>
                    <Firtst v-if="loadfirst"/>
                </CarouselItem>
                <CarouselItem>
                    <Second v-if="loadsecond"/>
                </CarouselItem>
            </Carousel>
            <footer class="footer1">
                <div type="text" style="box-shadow: none;';" size="small" ghost>
                     <a @click="statement">特别声明</a> |
                    <a href="http://beian.miit.gov.cn/" target="_black"
                    >蜀ICP备20000433号-1</a> | <span style="color: #bbbbbb"><Icon size="22" type="ios-call" />服务热线：<span class="tel">028-66612366</span></span>
                </div>
                <div>友情链接：<a href="http://www.zzcfo.cn/" target="_black">万和众智业财税法企服平台</a> <a href="https://www.chinatax.gov.cn/" target="_black">国家税务总局</a> <a href="https://12366.chinatax.gov.cn/" target="_black">12366纳税服务平台</a></div>
                <div>Copyright © 2020 www.holywiser.com 众智云擎 版权所有</div>
            </footer>
        </div>

        <Modal v-model="modalStateMent" width="600" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>特别声明</span>
            </p>
            <div style="height:400px;overflow-y: auto;">
                <Statement ref="statementContent"></Statement>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="closeStateMent">我知道了</Button>
                <!--  <Button type="primary" size="large" @click="sumitClearDocs">确定</Button> -->
            </div>
        </Modal>
    </div>
</template>
<script>
    import Second from './home/second.vue'
    import Firtst from './home/first.vue'
    import statement from './stateMent.vue'
    export default {
        name: 'homev2',
        data() {
            return {
                showHome: false,
                modalStateMent: false,
                value: 0,
                loadfirst:false,
                loadsecond:false,
            }
        },
        components: {
            Second,
            Firtst,
            "Statement": statement,
        },
        beforeCreate() {
            let count = 0
            let imgs = [
                require('../assets/images/home/bg_round.png'),
                require('../assets/images/home/bg_rhombus.png'),
                require('../assets/images/home/bg_rhombus2.png'),
                require('../assets/images/home/bg_top_round.png'),
                require('../assets/images/home/computer.png'),
                require('../assets/images/home/logo.png'),
                require('../assets/images/home/logov1.png'),
                require('../assets/images/home/newhomebg.png'),
                require('../assets/images/home/qrcode.png'),

                require('../assets/images/home/fxjc/bannedn.png'),
                require('../assets/images/home/fxjc/bannerdl2.png'),
                require('../assets/images/home/fxjc/bjt.png'),
                require('../assets/images/home/fxjc/bjt2.png'),
                require('../assets/images/home/fxjc/dwfxfxbg.png'),
                require('../assets/images/home/fxjc/fxgl.png'),
                require('../assets/images/home/fxjc/fxpg.png'),
                require('../assets/images/home/fxjc/gzlfxglmx.png'),
                require('../assets/images/home/fxjc/qfmfxty.png'),
                require('../assets/images/home/fxjc/slt1.png'),
                require('../assets/images/home/fxjc/slt2.png'),
                require('../assets/images/home/fxjc/swsjzx.png'),
                require('../assets/images/home/fxjc/zbfa.png'),

            ]
            for (let img of imgs) {
                let image = new Image()
                image.src = img
                image.onload = () => {
                    console.log('loading img' + count)
                    count++
                    if (count == imgs.length) {
                        this.bgroundReady()
                    }
                }
            }
        },
        mounted() {
            // 解决轮播图初始化宽度为0的问题
            this.carousel()
        },
        created() {
            this.handleSpinCustom()
            console.log('分辨率:' + window.screen.width + '*' + window.screen.height)
            //this.carousel()
        },
        methods: {

            gotoIndex() {
                this.$router.push('localsearch')
            },
            bgroundReady() {
                console.log('bgroundReady=======>')
                this.showHomeBG()
            },
            showHomeBG() {
                setTimeout(() => {
                    this.loadsecond=true
                    this.$Spin.hide()
                }, 1000)
                this.loadfirst=true
                this.showHome = true
                //加载完成强制resize触发轮播适应
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'))
                }, 200)

                //this.carousel()
            },
            handleSpinCustom() {
                this.$Spin.show({
                    render: (h) => {
                        return h('div', [
                            h('Icon', {
                                class: 'demo-spin-icon-load',
                                props: {
                                    type: 'ios-loading',
                                    size: 18,
                                },
                            }),
                            h(
                                'div',
                                {
                                    domProps: {
                                        style: 'font-size:14px;font-weight:bold;',
                                    },
                                },
                                '众智云擎加载中...'
                            ),
                        ])
                    },
                })
            },

            statement() {
                this.modalStateMent = true
            },
            closeStateMent() {
                this.modalStateMent = false
            },
            carousel(){
                // 解决轮播图初始化宽度为0的问题
                this.$nextTick(() => {
                    setTimeout(()=>{
                            // 先设置宽度
                        const carouselList = document.querySelector('.ivu-carousel-list')
                        const carouselTrack = document.querySelector('.ivu-carousel-track')
                        if (carouselList) carouselList.style.width = '100%'
                        if (carouselTrack) carouselTrack.style.width = '100%'

                        // 触发窗口resize事件，强制轮播图重新计算宽度
                        window.dispatchEvent(new Event('resize'))
                        // 延迟200ms后再次触发
                        setTimeout(() => {
                            window.dispatchEvent(new Event('resize'))
                        }, 200)
                    },100)
                        
                })
            }
        },
    }
</script>
<style lang="less" scoped>
    .site {
        display: flex;
        min-height: 100%;
        width: 100%;
        flex-direction: column;
    }

    .headerbox {
        display: flex;
        position: fixed;
        width: 100%;
        z-index: 200;
        background-color: #fff;
    }

    .header {
        margin: 10px;
        flex: 1;
        background-color: white;
        display: flex;
    }

    .cloumn1 {
        display: flex;
        flex: 5;
        justify-content: center;
        align-items: center;
    }

    .cloumn2 {
        display: flex;
        flex: 5;
        justify-content: center;
        align-items: center;
    }

    .button {
        border-radius: 30px;
        width: 130px;
        background-color: #286cfb;
        border: none;
        box-shadow: none;
    }

    .swiper {
        flex: 1;
        margin-top: 50px;
        overflow-y: auto;
        min-width: 1250px;
    }

    .footer1 {
        flex: 1;
        background-color: #17233d;
        height: 80px;
        text-align: center;
        justify-content:center;
        display:felx;
        padding-top:5px;
    }
    .tel{
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
    }

</style>
<style>
/*.ivu-carousel-arrow{
    width:36px !important;
}*/
</style>
